import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, FormBuilder } from '@angular/forms';
import {ApiProviderService} from '../services/api-provider.service';
import {ExtraComponentsComponent} from '../extra-components/extra-components.component';

@Component({
  selector: 'app-cloud-pbx',
  templateUrl: './cloud-pbx.component.html',
  styleUrls: ['./cloud-pbx.component.scss']
})
export class CloudPbxComponent {

  moreInfoForm;
  moreInfoFormErrors;
  sendingInfoQueryDetails = 0;
  showSendInfoQuerySuccess = 0;

  constructor(public formBuilder: FormBuilder, public apiCalls: ApiProviderService, public extraComponent: ExtraComponentsComponent) {
    this.moreInfoForm = this.formBuilder.group({
        name : '',
        email : '',
        phone_number : '',
        reason : 'I\'m looking for VoIP Consulting',
        subject : '',
        message : ''
    });
  }

  submitMoreInfoFormDetails() {
      const moreInfoFormDetails = this.moreInfoForm.value;
      if (!moreInfoFormDetails.name) {
          this.moreInfoFormErrors = 'Enter Name';
          return;
      } else if (!moreInfoFormDetails.email) {
          this.moreInfoFormErrors = 'Enter Email';
          return;
      } else if (moreInfoFormDetails.phone_number && !this.extraComponent.validatePhoneNumber(moreInfoFormDetails.phone_number)) {
          this.moreInfoFormErrors = 'Phone Number Is Not Valid';
          return;
      } else if (moreInfoFormDetails.email && !this.extraComponent.validateEmail(moreInfoFormDetails.email)) {
          this.moreInfoFormErrors = 'Email Is Not Valid';
          return;
      } else if (!moreInfoFormDetails.subject) {
          this.moreInfoFormErrors = 'Enter Subject';
          return;
      }

      this.moreInfoFormErrors = undefined;

      this.postContactUsDetails(moreInfoFormDetails);
  }

    postContactUsDetails(postData) {
        this.sendingInfoQueryDetails = 1;
        this.apiCalls.submitContactUsDetails(postData).subscribe(
            (res) => {
                this.sendingInfoQueryDetails = 0;
                console.log(res);
            },
            (err) => {
                setTimeout(() => {
                    this.sendingInfoQueryDetails = 0;
                    this.showSendInfoQuerySuccess = 1;
                }, 2000);
                console.log(err);
            }
        )
    }

}
